var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.04,54c-7.18,1.6-12.66,7.7-13.33,15.19-7-.24-12.6-5.99-12.6-13.04s5.84-13.05,13.05-13.05c6.47,0,11.85,4.72,12.87,10.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.39,56.15c0,6.81-5.22,12.4-11.87,13-.71-7.71-6.52-13.94-14.03-15.29,1.08-6.11,6.42-10.76,12.85-10.76,7.21,0,13.05,5.84,13.05,13.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.97,96c0,1.32-.09,2.62-.26,3.89h-12.49c-3.53-7.21-9.12-12.84-15.85-15.78,3.64-2.59,6.23-6.57,6.99-11.16.09-.53.15-1.07.19-1.61.12,0,.24,0,.36,0,1.53,0,3.03.19,4.47.56h0c9.48,2.4,16.58,12.29,16.58,24.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.81,114.03c0,1.56-.1,3.1-.31,4.59h-49.15c-.2-1.5-.31-3.03-.31-4.59,0-4.87,1.02-9.47,2.82-13.5,2.93-6.57,7.95-11.67,14.01-14.1.53-.21,1.12-.2,1.64.03,1.48.65,3.07,1.1,4.74,1.31.67.09,1.36.13,2.05.14.04,0,.09,0,.13,0,2.28,0,4.46-.45,6.45-1.26.53-.22,1.14-.21,1.67.02,5.81,2.52,10.59,7.5,13.43,13.86,1.8,4.04,2.82,8.63,2.82,13.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.15,
    cy: 70.62,
    r: 13.76
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.59,95.91c0,1.32.09,2.62.26,3.89h12.49c3.53-7.21,9.12-12.84,15.85-15.78-3.64-2.59-6.23-6.57-6.99-11.16-.09-.53-.15-1.07-.19-1.61-.12,0-.24,0-.36,0-1.53,0-3.03.19-4.47.56h0c-9.48,2.4-16.58,12.29-16.58,24.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.4,13.08v4.49c29.99,2.91,53.83,27.14,56.14,57.31h4.48c-2.32-32.63-28.16-58.87-60.62-61.8ZM142.43,85.76c-2.87,29.56-26.46,53.15-56.03,56.03v4.49c32.04-2.89,57.63-28.48,60.52-60.52h-4.49ZM18.21,85.76h-4.49c2.93,32.46,29.16,58.3,61.8,60.62v-4.48c-30.16-2.31-54.39-26.15-57.31-56.14ZM13.62,74.88h4.48c2.34-30.59,26.84-55.08,57.42-57.42v-4.48c-33.06,2.35-59.55,28.84-61.9,61.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.84,2.88v25.6c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88V2.88c0-1.59,1.29-2.88,2.88-2.88s2.88,1.29,2.88,2.88Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.84,131.52v25.6c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88v-25.6c0-1.59,1.29-2.88,2.88-2.88s2.88,1.29,2.88,2.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.36,80.32c0,1.59-1.29,2.88-2.88,2.88H2.88c-1.59,0-2.88-1.29-2.88-2.88s1.29-2.88,2.88-2.88h25.6c1.59,0,2.88,1.29,2.88,2.88Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160,80.32c0,1.59-1.29,2.88-2.88,2.88h-25.6c-1.59,0-2.88-1.29-2.88-2.88s1.29-2.88,2.88-2.88h25.6c1.59,0,2.88,1.29,2.88,2.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/Customers.08fe0a421706de5b3cb82940f3b6f3df.svg";
export { ForwardRef as ReactComponent };